import { Input, Menu } from 'antd';
import * as React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';

import buildTree from '../../../helpers/tree';

export interface ISideMenuProps extends RouteComponentProps<{ eshop: string }> {
  onChange: (id: string) => void;
  onSearch: (query: string) => void;
  categories: Array<GQL.ICategory>;
}

export class SideMenu extends React.PureComponent<ISideMenuProps> {

  public render() {
    return (
      <div>
        <Input.Search
          placeholder="Search by title"
          onSearch={(searchQuery: string) => {
            this.props.onSearch(searchQuery);
          }}
        />
        <Menu style={{ height: 'calc(100vh - 246px)', borderRight: '0' }} onClick={({ item, key }) => this.changeCategory(key)}>
          <Menu.Item key={'catalog-root'}>
            <Link to={`/${this.props.match.params.eshop}/application/catalog`}>Catalog</Link>
          </Menu.Item>
          {this.renderCategories(
            buildTree(
              this.props.categories.map((c: GQL.ICategory) => {
                return {
                  ...c,
                  parentId: c.parentCategory ? c.parentCategory.id : undefined
                };
              }),
              'parentId',
              'id'
            )
          )}
        </Menu>
      </div>
    );
  }

  private changeCategory(id: string) {
    this.props.onChange(id);
  }

  private renderCategories(categories: any) {
    return categories.map((category: any, index: number) => {
      if (category.children.length > 0) {
        return (
          <Menu.SubMenu title={category.name['en'] || category.title} key={category.id}>
            <Menu.Item key={category.id}>
              <Link to={`/${this.props.match.params.eshop}/application/catalog/${category.id}`}>
                <b>{category.name['en'] || category.title}</b>
              </Link>
            </Menu.Item>
            {this.renderCategories(category.children)}
          </Menu.SubMenu>
        );
      }

      return (
        <Menu.Item key={category.id}>
          <Link to={`/${this.props.match.params.eshop}/application/catalog/${category.id}`}>
            {category.name['en'] || category.title}
          </Link>
        </Menu.Item>
      );
    });
  }
}

export default withRouter(SideMenu);



// WEBPACK FOOTER //
// ./src/scenes/Catalog/components/SideMenu.tsx